import { utcToZonedTime as c, zonedTimeToUtc as i } from "date-fns-tz";
import { ConfigService as a, request as g } from "@nextgen-web-framework/core";
import { Language as u, Locale as m } from "../types/enums/promotionEnums.js";
const { EN: l, TH: T, ES: D } = u, { EN_US: f, TH_TH: E, ES_CO: d } = m, p = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], N = (e) => {
  const { NEXT_PUBLIC_TIMEZONE: t } = a.getConfigs();
  return new Date(c(e, t));
}, h = (e) => {
  const { NEXT_PUBLIC_TIMEZONE: t } = a.getConfigs();
  return i(e, t);
}, C = (e, t = !0, s = !1) => {
  const o = t ? N(e) : new Date(e);
  return `${`${String(o.getDate())} ${p[o.getMonth()]}${s ? "" : ","} ${String(
    o.getFullYear()
  )}`}, ${new Date(o.getTime()).toLocaleTimeString(navigator.language, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: !1
  })}`;
}, L = (e) => {
  const t = new Date(e);
  return t.setHours(0, 0, 0, 0), t;
}, w = {
  [f]: l,
  [E]: T,
  [d]: D
}, M = async (e, t, s) => {
  const { baseUrl: o, headers: n } = t ?? {}, r = await g(
    {
      ...e,
      ...o && { url: `${o}${e.url}` },
      ...n && { headers: n }
    },
    s ?? {
      skipIdempotency: !0
    }
  );
  return Promise.resolve(r);
}, I = (e) => {
  var o, n;
  const t = e == null ? void 0 : e.responseBody;
  return ((n = (o = t == null ? void 0 : t.subDetails) == null ? void 0 : o[0]) == null ? void 0 : n.message) || (t == null ? void 0 : t.detail);
}, U = (e) => new Promise((t) => setTimeout(() => t(), e));
export {
  C as formatDate,
  I as getApiErrorMessage,
  L as getDateWithoutTime,
  M as handleRequest,
  w as languagesByLocale,
  p as monthNames,
  U as syncDelay,
  h as toCustomDate,
  N as toLocalDate
};
//# sourceMappingURL=commonHelper.js.map
